import { z } from "zod";

import { conditionBuildWithoutChildrenSchema } from "../shared/index.ts";
export type { ConditionBuildWithoutChildren } from "../shared/index.ts";

export const conditionSlotsByParentIdSchema = z.record(
  z.record(z.union([z.number().int(), z.array(z.number().int()), z.undefined()])),
);

export type ConditionSlotsByParentId = z.infer<typeof conditionSlotsByParentIdSchema>;

export const conditionsStateSchema = z.object({
  idByResponseId: z.record(z.number().int()),
  idByTriggerId: z.record(z.number().int()),
  slotsByParentId: conditionSlotsByParentIdSchema,
  byId: z.record(conditionBuildWithoutChildrenSchema.omit({ id: true })),
  parentIdByChildId: z.record(z.number().int()),
  responseIdByRootConditionId: z.record(z.number().int()),
  triggerIdByRootConditionId: z.record(z.number().int()),
});

export type ConditionsState = z.infer<typeof conditionsStateSchema>;
